import styled from 'styled-components';
import {Row, RowW50Styles, Column} from '../../common/Layouts/Layouts';

export const RoomTypeLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-direction: column;
  max-width: 120rem;
  margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.white.base};
  border: 1px solid ${props.theme.colors.grey.lightc3};
  border-radius: ${props.theme.misc.borderRadius.xxlarge};  
`,
);

export const RoomTypeLoaderInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 120rem;
  width:20%;
  background-color:${props.theme.colors.white.base};
  border-radius:${props.theme.misc.borderRadius.large};

`,
);

export const RoomTypeLoaderContentWrapDiv = styled.div(
  props => `
    display:flex;
  `,
);

export const RoomTypeLoaderContentLeftDiv = styled.div(
  props => `
  width: 42rem;
  border-right: 1px solid #dcddde;
  padding: ${props.theme.spacing.large.l20};

`,
);

export const RoomTypeLoaderContentRightDiv = styled.div(
  props => `
    display:flex;
    width: 77.8rem;
    border-bottom: 5px solid #dcddde;
  `,
);

export const RoomTypeLoaderHeaderDiv = styled.div(
  props => `
    width: ${props.width};
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};  
    text-transform: ${props.theme.font.textTransform.upper};
    border-right: 1px solid ${props.theme.colors.grey.lightba};
  `,
);

export const RoomTypeLoaderOptionsDiv = styled.div(
  props => `
    border-right: 1px solid #dcddde;
    padding: ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l20};
    width: 37.8rem;
  `,
);

export const RoomTypeLoaderOptionsTextDiv = styled.div(
  props => `
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius: ${props.theme.misc.borderRadius.small};
    margin-bottom:${props.theme.spacing.base};
    width: 16.3rem;
    height: 1.8rem;
`,
);

export const RoomTypeLoaderOptionsTextLargeDiv = styled.div(
  props => `
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    width:22.2rem;
    height:2.5rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    margin-bottom:${props.theme.spacing.large.l20};
`,
);

export const RoomTypeLoaderHeaderWrapDiv = styled.div(
  props => `
    display:flex;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-bottom: 1px solid ${props.theme.colors.grey.lightba};
    border-radius: ${props.theme.misc.borderRadius.xxlarge} ${props.theme.misc.borderRadius.xxlarge} 0 0; 
  `,
);

export const RoomTypeLoaderTypeTextDiv = styled.div(
  props => `

  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  width:16.3rem;
  height:1.6rem;
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};;
`,
);

export const RoomTypeLoaderImgDiv = styled.div(
  props => `

  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  width: 39rem;
  height: 19.3rem;
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};;

`,
);

export const RoomTypeLoaderDescpDiv = styled.div(
  props => `

  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  width:21.6rem;
  height:3.8rem;
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-top:${props.theme.spacing.large.l30};

`,
);

export const RoomTypeLoaderInclusionsDiv = styled.div(
  props => `

  border-right: 1px solid #dcddde;
  padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l20};
  width: 36%;

`,
);

export const RoomTypeLoaderInclusionsTextDiv = styled.div(
  props => `

  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:19.8rem;
  height:1.8rem;

`,
);

export const RoomTypeLoaderPriceDescpDiv = styled.div(
  props => `

  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-top:${props.theme.spacing.large.l50} ;
  margin-bottom:${props.theme.spacing.base};
  width:17.4rem;
  height:4.4rem;

`,
);

export const RoomTypeLoaderPriceDiv = styled.div(
  props => `
    padding: ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l20};;
    width: 40rem;
  `,
);

export const RoomTypeLoaderPricesTextDiv = styled.div(
  props => `
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius: ${props.theme.misc.borderRadius.small};
    margin-bottom:${props.theme.spacing.base};
    width:17.5rem;
    height:2.3rem;
`,
);

export const RoomTypeLoaderPricesSmallTextDiv = styled.div(
  props => `

  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:12.1rem;
  height:1.8rem;

`,
);

export const RoomTypeLoaderPricesSmallerTextDiv = styled.div(
  props => `

  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:12.1rem;
  height:1.4rem;

`,
);

export const RoomTypeLoaderPriceLargeTextDiv = styled.div(
  props => `

  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:15.7rem;
  height:1.8rem;

`,
);
